// @tenorlab/vue-dashboard-pro
// file: src/components/shared/index.ts
export * from './use-echart-interval'
export * from './use-resolved-colors'

import WidgetChartBase from './WidgetChartBase.vue'
export { WidgetChartBase }

export const smallCardClasses = {
  outerDiv: 'flex flex-col justify-between gap-2 w-full h-full',
  labelDiv: 'font-semibold text-xs',
  valueDiv: 'pr-2.5 text-primary',
  valueLarge: 'text-4xl',
  valueSmall: 'text-xl font-light',
  dateDiv: 'flex flex-row justify-end',
  dateText: 'h-min text-[0.65rem]',
}
